import { BaseDrawOption } from '@/modules/ta/widget/models/drawoptions/BaseDrawOption';
import {
  PlotType,
  SparkLineTypes,
  WidgetReportDisplayLength,
  WidgetSparklineOptions,
} from '@/modules/ta/widget/widget.constants';
import {
  DatagridDefaultNumberOfPage,
  DatagridDefaultRowsPerPage,
} from '@/modules/ta/widget/builder.constants';

export class DataGridDrawOption extends BaseDrawOption {
  /**
   * @var {}
   */
  grid_paginate;

  /**
   * @var {}
   */
  grid_is_responsive;

  /**
   * @var {}
   */
  grid_collapse_in_modal;

  /**
   * @var {}
   */
  grid_alternating_row_color;

  /**
   * @var {}
   */
  show_total_row;

  /**
   * @var {}
   */
  grid_total_row_bottom;

  /**
   * @var {number}
   */
  grid_font_size;

  /**
   * @var {object}
   */
  grid_font_properties;

  /**
   * @var {}
   */
  grid_full_image_size;

  /**
   * @var {}
   */
  grid_preview_as_iframe;

  /**
   * @var {}
   */
  pivot_grid;

  /**
   * @var {}
   */
  grid_iframe_capture_delay;

  /**
   * @var {number}
   */
  display_length;

  /**
   * @var {number}
   */
  report_display_length;

  /**
   * @var {}
   */
  percent_of_total;

  /**
   * @var {}
   */
  grid_theme;

  /**
   * @var {}
   */
  wrap_text_name;

  /**
   * @var {}
   */
  stylized_excel;

  /**
   * @var {}
   */
  embed_sparklines_type;

  /**
   * @var {}
   */
  embed_sparkline_date_range;

  /**
   * @var {boolean}
   */
  grid_week_range;

  /**
   * @var {boolean}
   */
  split_in_multiple_pages;

  /**
   * @var {number}
   */
  rows_per_page;

  /**
   * @var {number}
   */
  number_of_page;

  /**
   * @var {boolean}
   */
  repeat_full_layout;

  constructor(model = {}) {
    super(model);

    this.setValidPlotType(model);

    this.report_display_length = model.report_display_length ?? null;
    this.display_length = model.display_length ?? 10;
    this.grid_paginate = model.grid_paginate ?? false;
    this.grid_is_responsive = model.grid_is_responsive ?? false;
    this.grid_collapse_in_modal = model.grid_collapse_in_modal ?? true;
    this.grid_alternating_row_color = model.grid_alternating_row_color ?? false;
    this.grid_max_height_image = model.grid_max_height_image ?? 0;
    this.show_total_row = model.show_total_row ?? false;
    this.grid_total_row_bottom = model.grid_total_row_bottom ?? false;
    this.grid_font_size = model.grid_font_size ?? 12;
    this.grid_font_properties = model.grid_font_properties ?? {};
    this.grid_full_image_size = model.grid_full_image_size ?? false;
    this.grid_preview_as_iframe = model.grid_preview_as_iframe ?? false;
    this.grid_iframe_capture_delay = model.grid_iframe_capture_delay ?? 3;
    this.percent_of_total = model.percent_of_total ?? false;
    this.grid_theme = model.grid_theme ?? false;
    this.wrap_text_name = model.wrap_text_name ?? true;
    this.stylized_excel = model.stylized_excel ?? true;
    this.embed_sparklines_type = model.embed_sparklines_type ?? SparkLineTypes.LINE;
    this.embed_sparkline_date_range =
      model.embed_sparkline_date_range ?? WidgetSparklineOptions.LAST_3_MONTHS;
    this.grid_week_range = model.grid_week_range ?? false;
    this.split_in_multiple_pages = model.split_in_multiple_pages ?? false;
    this.rows_per_page = model.rows_per_page ?? DatagridDefaultRowsPerPage;
    this.number_of_page = model.number_of_page ?? DatagridDefaultNumberOfPage;
    this.repeat_full_layout = model.repeat_full_layout ?? false;
    this.setValidPivotGrid(model);
  }

  setValidPlotType(model) {
    const validTypes = [
      PlotType.DEFAULT,
      PlotType.CLASSIC,
      PlotType.CONDITIONAL_MAP,
      PlotType.GROUPED_COLUMN,
      PlotType.EMBEDDED_SPARKLINE,
      PlotType.HEAT_MAP,
    ];

    if (!model.plot_type || !validTypes.includes(model.plot_type)) {
      this.plot_type = PlotType.DEFAULT;
    } else {
      this.plot_type = model.plot_type;
    }
  }

  setValidPivotGrid(model) {
    this.pivot_grid = [PlotType.DEFAULT, PlotType.CLASSIC].includes(model.plot_type)
      ? model.pivot_grid ?? false
      : false;
  }
}
